import useAuthStore from '@/stores/authStore';
import type { NavigationGuardWithThis } from 'vue-router';

export default <NavigationGuardWithThis<undefined>>((to, _from, next) => {
  const authStore = useAuthStore();
  if (
    authStore.isAuth &&
    !['dashboard', 'company.index'].includes(to.name as string)
  ) {
    return next({
      name: authStore.isDashboard ? 'dashboard' : 'company.index',
    });
  }

  return next();
});
